export default (isSmall, toggle) => () => isSmall && toggle()
